import { Apartment } from '@dwellet/dwellet-utils'
import { Button, CircularProgress, Grid, Typography } from '@material-ui/core'
import i18n from 'i18next'
import { FC, Fragment } from 'react'
import { Field } from 'redux-form'
import {
  ReduxFormField,
  ReduxGoogleAutocomplete
} from '../../../../components/FormInput/ReduxWrappers'
import { onlyNums, noNums } from '../../../../libs/normalize/information'
import { MuiClasses } from '../../../../types'
import { AutocompleteOption } from '../../../../types/autocomplete'
import {
  required,
  isPostalCode,
  requiredLocation,
  validateIban,
  stripSpaces
} from '../../../../utils/validation/forms'
import { MyInput } from '../../../NewApplication/Fields'
import BusinessClient from './BusinessClient'

interface ClientProps {
  t: i18n.TFunction
  hasOtherOwners: string | undefined
  isDisabled: boolean
  isBusiness: boolean
  isPrivate: boolean
  isRealtor: boolean
  isLandlord: boolean
  autocompleteLocation?: AutocompleteOption
  changeFormValue: (field: string, value: string) => void
  classes: MuiClasses
  doStepBack: any
  updateClientInfoWithStatus: any
  updateClientInfoToOverview: any
  updateClientInfoToOverviewEditMode: any
  updateClientInfo: any
  currentStep: number
  customSubmitLabel: any
  apartment: Apartment
  isLoading: boolean
}

const Client: FC<ClientProps> = ({
  t,
  hasOtherOwners,
  isDisabled,
  isBusiness,
  isRealtor,
  isLandlord,
  isPrivate,
  autocompleteLocation,
  changeFormValue,
  classes,
  doStepBack,
  updateClientInfoWithStatus,
  updateClientInfo,
  updateClientInfoToOverview,
  updateClientInfoToOverviewEditMode,
  currentStep,
  customSubmitLabel,
  apartment,
  isLoading
}) => {
  return (
    <Grid container>
      <Grid container>
        <Grid item xs={12} sm={12}>
          <Grid
            className={classes.largeForm}
            style={{ paddingTop: '0' }}
            container
          >
            {' '}
            <Grid container spacing={1}>
              <Grid item sm={12} className={classes.containerItem}>
                <Typography variant='h5' gutterBottom>
                  {t('apartment.clientInformation')}
                </Typography>
              </Grid>
              {isRealtor ? (
                <>
                  <Grid item xs={12} md={7} className={classes.containerItem}>
                    <Typography variant='body1' gutterBottom>
                      {t('person.fullName')}
                    </Typography>
                    <ReduxFormField
                      name='mainOwner.clientName'
                      validate={[required]}
                      component={MyInput}
                      style={{
                        width: '100%',
                        height: '58px',
                        padding: '20px',
                        background: '#E7ECEF'
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={5} className={classes.containerItem}>
                    <Typography variant='body1' gutterBottom>
                      {t('person.phoneNum')}
                    </Typography>
                    <ReduxFormField
                      name='mainOwner.clientPhone'
                      component={MyInput}
                      validate={[required]}
                      style={{
                        width: '100%',
                        height: '58px',
                        padding: '20px',
                        background: '#E7ECEF'
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} className={classes.containerItem}>
                    <Typography variant='body1' gutterBottom>
                      {t('person.email')}
                    </Typography>
                    <ReduxFormField
                      name='mainOwner.clientEmail'
                      component={MyInput}
                      validate={[required]}
                      style={{
                        width: '100%',
                        height: '58px',
                        padding: '20px',
                        background: '#E7ECEF'
                      }}
                      normalize={stripSpaces}
                    />
                  </Grid>
                </>
              ) : null}

              {isBusiness && (
                <BusinessClient
                  t={t}
                  classes={classes}
                  isDisabled={isDisabled}
                />
              )}
              <Grid item xs={12} className={classes.containerItem}>
                <Typography variant='body1' gutterBottom>
                  {t(
                    isPrivate ? 'person.homeAddress' : 'business.companyAddress'
                  )}
                </Typography>
                <Field
                  fullWidth
                  name='mainOwner.autocompleteLocation'
                  selectLabel={t('autocomplete.select')}
                  existingLocations={[]}
                  required
                  changeFormValue={changeFormValue}
                  component={ReduxGoogleAutocomplete}
                  validate={[requiredLocation]}
                  isFromClientForm={true}
                />
              </Grid>
              <Grid item xs={12} sm={12} className={classes.containerItem}>
                <Typography variant='body1' gutterBottom>
                  {t('person.buildingLetterAndApartmentNumber')}
                </Typography>
                <ReduxFormField
                  name='mainOwner.buildingLetter'
                  component={MyInput}
                  disabled={isDisabled}
                  style={{
                    width: '100%',
                    height: '58px',
                    padding: '20px',
                    background: '#E7ECEF'
                  }}
                />
              </Grid>
              {/* <Grid item xs={12} sm={6} className={classes.containerItem}>
                <Typography variant='body1' gutterBottom>
                  {t('person.apartmentNumber')}
                </Typography>
                <ReduxFormField
                  name='mainOwner.apartmentNumber'
                  disabled={isDisabled}
                  normalize={onlyNums}
                  component={MyInput}
                  style={{
                    width: '100%',
                    height: '58px',
                    padding: '20px',
                    background: '#E7ECEF'
                  }}
                  type='number'
                />
              </Grid> */}
              {autocompleteLocation && (
                <Fragment>
                  <Grid item xs={12} sm={4} className={classes.containerItem}>
                    <Typography variant='body1' gutterBottom>
                      {t('person.postalCode')}
                    </Typography>
                    <ReduxFormField
                      name='mainOwner.postalCode'
                      normalize={onlyNums}
                      min={0}
                      validate={[required, isPostalCode]}
                      disabled={isDisabled}
                      component={MyInput}
                      style={{
                        width: '100%',
                        height: '58px',
                        padding: '20px',
                        background: '#E7ECEF'
                      }}
                      required
                    />
                  </Grid>
                  <Grid item xs={12} sm={8} className={classes.containerItem}>
                    <Typography variant='body1' gutterBottom>
                      {t('person.postalArea')}
                    </Typography>
                    <ReduxFormField
                      name='mainOwner.postalArea'
                      normalize={noNums}
                      validate={[required]}
                      disabled={isDisabled}
                      component={MyInput}
                      style={{
                        width: '100%',
                        height: '58px',
                        padding: '20px',
                        background: '#E7ECEF'
                      }}
                      required
                    />
                  </Grid>
                </Fragment>
              )}
              <Grid
                item
                xs={12}
                sm={12}
                className={classes.containerItem}
                style={{ display: 'none' }}
              >
                <Typography variant='body1' gutterBottom>
                  {t('IBAN')}
                </Typography>
                <ReduxFormField
                  name='mainOwner.iban'
                  component={MyInput}
                  style={{
                    width: '100%',
                    height: '58px',
                    padding: '20px',
                    background: '#E7ECEF'
                  }}
                  validate={[validateIban]}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid
            style={{
              justifyContent: 'space-between',
              marginTop: '15px',
              maxWidth: '560px'
            }}
            container
          >
            <Grid item sm={12} xs={12}>
              <Grid container xs={12} sm={12}>
                {(!currentStep || (currentStep && !apartment?.client)) && (
                  <Grid item xs={6}>
                    {/* <input type='hidden' name='confirm' value={'true'} />
                    <SubmitButton
                      t={t}
                      id='confirm'
                      submit={!apartment?.client}
                      customLabel={t('apartment.list.client.publishLater')}
                      secondary
                      goToOverview={true}
                    /> */}
                    <Button
                      fullWidth
                      variant='contained'
                      color='primary'
                      id='ToOverview'
                      disabled={isDisabled || isLoading}
                      onClick={updateClientInfoToOverview}
                      className={classes.primaryBtn}
                    >
                      {isLoading ? (
                        <CircularProgress size={23} style={{ color: '#fff' }} />
                      ) : (
                        t('apartment.list.client.publishLater')
                      )}
                    </Button>
                  </Grid>
                )}
                {((currentStep && apartment?.client)) && (
                  <Grid item xs={6}>
                    {/* <input type='hidden' name='confirm' value={'true'} />
                    <SubmitButton
                      t={t}
                      id='confirm'
                      submit={!apartment?.client}
                      customLabel={t('apartment.list.client.publishLater')}
                      secondary
                      goToOverview={true}
                    /> */}
                    <Button
                      fullWidth
                      variant='contained'
                      color='primary'
                      id='ToOverview'
                      disabled={isDisabled || isLoading}
                      onClick={updateClientInfoToOverviewEditMode}
                      className={classes.primaryBtn}
                    >
                      {isLoading ? (
                        <CircularProgress size={23} style={{ color: '#fff' }} />
                      ) : (
                        t('apartment.list.client.publishLater')
                      )}
                    </Button>
                  </Grid>
                )}

                <Grid
                  item
                  xs={
                    !currentStep || (currentStep && !apartment?.client) ? 6 : 12
                  }
                >
                  {' '}
                  <input type='hidden' name='publish' value={'true'} />
                  {/* <SubmitButton
                    t={t}
                    id='publish'
                    submit
                    customClickHandler={updateClientInfoWithStatus}
                    customLabel={
                      apartment?.client
                        ? t('apartment.list.client.confirmChanges')
                        : t('apartment.list.client.confirmPublish')
                    }
                  /> */}
                  {/* <Button
                    fullWidth
                    variant='contained'
                    color='primary'
                    id='publish'
                    disabled={isDisabled}
                    onClick={updateClientInfo}
                    className={classes.primaryBtn}
                  >
                    {isLoading ? (
                      <CircularProgress
                        size={25}
                        style={{
                          color: '#fff',
                          marginLeft: '5px'
                        }}
                      />
                    ) : apartment?.client ? (
                      t('apartment.list.client.confirmPublish')
                    ) : (
                      t('paymentPage.confirmAndPay')
                    )}
                  </Button> */}
                  {/* <SubmitButton
                    t={t}
                    id='publish'
                    submit
                    customLabel={t('apartment.list.client.confirmPublish')}
                  /> */}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* <Grid item sm={12} style={{ marginTop: '10px' }}>
        <Typography variant='body1' gutterBottom>
          {t('apartment.otherOwnersTitle')}
        </Typography>
      </Grid>
      <Grid item sm={12}>
        <Typography variant='body1' gutterBottom>
          {t('apartment.otherOwners')}
        </Typography>
        <Field name='hasOtherOwners' component={ReduxRadioGroup}>
          <FormControlLabel
            value='true'
            control={<Radio disabled={isDisabled} />}
            label={t('general.yes')}
          />
          <FormControlLabel
            value='false'
            control={<Radio disabled={isDisabled} />}
            label={t('general.no')}
          />
        </Field>
      </Grid> */}
      {/* {hasOtherOwners === 'true' && (
        <FieldArray
          name='otherOwners'
          isDisabled={isDisabled}
          component={OtherOwners}
        />
      )} */}
    </Grid>
  )
}

export default Client
